import React, { useState, useEffect } from 'react';
import AddLoadsModal from '../../../AddLoads';
import { GetLoadSummary_getLoadSummary_loadSummaries as LoadSummaryDetails } from '../../../../types/schemaTypes';
import {NumericFormat as NumberFormat} from 'react-number-format';
import CustomLoadInformationModal from '../../../LoadProfile/LoadProgress/CustomLoadInformationModal';

interface LOFAScheduleItemProps {
    index: number;
    proppantName: string | null;
    item: LoadSummaryDetails;
    jobId: number;
    jobName: string | null;
    customerId: number;
    region?: {
        regionName: string | null;
        id: number | null;
        extSystemName: string | null;
        extSystemReference: string | null;
        regionCode: string | null;
    } | null;
    selectedTab: string;
    isJobCompleted: boolean;
    isAddLoadsEnabled: boolean;
    onChange: (jobId: number, active: boolean) => void;
    errorMsg: string;
    successMsg: string;
}

const LoadSummaryItem = ({
    item,
    index,
    proppantName,
    jobId,
    jobName,
    customerId,
    region,
    selectedTab,
    isJobCompleted,
    isAddLoadsEnabled,
    onChange,
    errorMsg,
    successMsg,
}: LOFAScheduleItemProps): React.ReactElement => {
    const [showModal, setShowModal] = useState(false);

    const handleShowModal = (): void => {
        setShowModal(true);
    };
    const handleOnClickHide = (): void => {
        setShowModal(false);
        window.location.reload();
    };

    return (
        <div className="LoadSummary-Detail-Row" key={index}>
            <div className="LoadSummary-Detail-Item">{index === 0 ? proppantName : ''}</div>
            <div className="LoadSummary-Detail-Item">
                {isAddLoadsEnabled && isAddLoadsEnabled === true ? (
                    <input
                        type="checkbox"
                        className="FilterCheckBox-Checkbox"
                        checked={item.isActive ?? false}
                        onChange={(event): void => {
                            onChange(item.jobSummaryId ?? 0, event.currentTarget.checked);
                        }}
                        aria-label={`Toggle active status for ${item.lofaName}`}
                        title={`Toggle active status for ${item.lofaName}`}
                    />
                ) : (
                    <input
                        type="checkbox"
                        className="FilterCheckBox-Checkbox"
                        checked={item.isActive ?? false}
                        disabled
                        aria-label={`Active status for ${item.lofaName} (disabled)`}
                        title={`Active status for ${item.lofaName} (disabled)`}
                    />
                )}
            </div>
            <div className="LoadSummary-Detail-Item">
                {!isJobCompleted && item.isActive && (
                    <AddLoadsModal
                        proppantName={proppantName || undefined}
                        sandPo={item.sandPo || undefined}
                        transportationPo={item.transportationPo || undefined}
                        wellhead={jobName || undefined}
                        lofa={item.lofaName || undefined}
                        lofaId={item.lofaId || 0}
                        jobId={jobId}
                        jobSummaryId={item.jobSummaryId || undefined}
                        customerId={customerId}
                        region={region}
                        loadsRemaining={item.loadsRemaining || 0}
                        handleShowModal={handleShowModal}
                    />
                )}
            </div>
            <div className="LoadSummary-Detail-Item LoadSummary-Name LoadSummary-WrapText">{item.lofaName}</div>

            <div className="LoadSummary-Detail-Item LoadSummary-WrapText">{item.sandPo}</div>
            <div className="LoadSummary-Detail-Item LoadSummary-WrapText">{item.transportationPo}</div>
            <div className="LoadSummary-Detail-Item">
                <NumberFormat
                    value={selectedTab === 'Loads' ? item.loadsCreated || 0 : item.loadsCreatedVolume || 0}
                    displayType={'text'}
                    thousandSeparator={true}
                />
            </div>
            <div className="LoadSummary-Detail-Item">
                <NumberFormat
                    value={selectedTab === 'Loads' ? item.loadsInProgress || 0 : item.loadsInProgressVolume || 0}
                    displayType={'text'}
                    thousandSeparator={true}
                />
            </div>
            <div className="LoadSummary-Detail-Item">
                <NumberFormat
                    value={selectedTab === 'Loads' ? item.loadsCompleted || 0 : item.loadsCompletedVolume || 0}
                    displayType={'text'}
                    thousandSeparator={true}
                />
            </div>
            <div className="LoadSummary-Detail-Item">
                <NumberFormat
                    value={selectedTab === 'Loads' ? item.loadsRemaining || 0 : item.loadsRemainingVolume || 0}
                    displayType={'text'}
                    thousandSeparator={true}
                />
            </div>
            <div className="LoadSummary-Detail-Item"></div>
            <CustomLoadInformationModal
                show={showModal}
                onCancel={handleOnClickHide}
                text="The loads are in the process of being created and will be assigned shortly."
            />
        </div>
    );
};

export default LoadSummaryItem;
